<div class="row">
    <div class="col-xl-6">
        <div class="card mb-5">
            <div class="card-header-alt d-flex justify-content-between p-4">
                <div>
                    <h6 class="font-weight-bold font-size-lg mb-1 text-black">Revenue progress</h6>
                    <p class="text-black-50 mb-0">Our company revenues, split by progress.</p>
                </div>
                <div>
                    <button class="btn btn-outline-second" type="button">
                        <span class="btn-wrapper--icon">
                            <fa-icon [icon]="['fas', 'arrow-down']"></fa-icon>
                        </span>
                        <span class="btn-wrapper--label">
                            Download report
                        </span>
                    </button>
                </div>
            </div>
            <div class="mx-4 divider"></div>
            <div class="mx-4 divider"></div>
            <div class="p-4">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="p-4 mb-4 rounded bg-secondary">
                            <div class="mb-4">
                                <div class="line-height-1">
                                    <span class="font-size-lg font-weight-bold pr-3">54,126</span>
                                    <span class="text-muted">dribbble.com</span>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="flex-grow-1">
                                        <progressbar [value]="50" class="progress-bar-rounded progress-xs"
                                                     type="success"></progressbar>
                                    </div>
                                    <div class="text-dark font-weight-bold pl-3">
                                        50%
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="line-height-1">
                                    <span class="font-size-lg font-weight-bold pr-3">12,345</span>
                                    <span class="text-muted">amazon.com</span>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="flex-grow-1">
                                        <progressbar [value]="76" class="progress-bar-rounded progress-xs"
                                                     type="info"></progressbar>
                                    </div>
                                    <div class="text-dark font-weight-bold pl-3">
                                        76%
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="line-height-1">
                                    <span class="font-size-lg font-weight-bold pr-3">34,985</span>
                                    <span class="text-muted">facebook.com</span>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="flex-grow-1">
                                        <progressbar [value]="87" class="progress-bar-rounded progress-xs"
                                                     type="first"></progressbar>
                                    </div>
                                    <div class="text-dark font-weight-bold pl-3">
                                        87%
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="line-height-1">
                                    <span class="font-size-lg font-weight-bold pr-3">76,381</span>
                                    <span class="text-muted">youtube.com</span>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="flex-grow-1">
                                        <progressbar [value]="59" class="progress-bar-rounded progress-xs"
                                                     type="danger"></progressbar>
                                    </div>
                                    <div class="text-dark font-weight-bold pl-3">
                                        59%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <apx-chart
                                [chart]="{
                                type: 'bar',
                                height: '280',
                                sparkline: {
                                  enabled: true
                                },
                                stacked: true
                            }"
                                [colors]="['#7fe4a6', '#7fe2ec', '#7fc8fd', '#ff98a4']"
                                [dataLabels]="{
                              enabled: true
                            }"
                                [fill]="{
                              opacity: 1
                            }"

                                [labels]="['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'Last week', 'Last month']"
                                [legend]="{ show: false }"
                                [plotOptions]="{
                              bar: {
                                horizontal: false,
                                endingShape: 'rounded',
                                columnWidth: '80%'
                              }
                            }"

                                [series]="[
                              {
                                name: 'Net Profit',
                                data: [2.3, 3.1, 4.0, 3.8, 5.1, 3.6,4.0, 3.8, 5.1]
                              },
                              {
                                name: 'Weekly Stats',
                                data: [2.3, 3.1, 5.1, 3.6,4.0, 4.0, 3.8,  3.6,3.8]
                              },
                              {
                                name: 'Sales reports',
                                data: [2.3, 3.1, 5.1, 3.6,4.0, 4.0, 3.8,  3.6,3.8]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 3.0, 2.8, 4.0, 3.8, 5.1, 3.6,4.1]
                              }
                            ]"

                                [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
                        ></apx-chart>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="divider"></div>
            </div>
            <div class="text-center mb-4">
                <button class="btn btn-first" type="button">
                    <span class="btn-wrapper--label">
                        View complete report
                    </span>
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header-alt d-flex justify-content-between p-4">
                <div>
                    <h6 class="font-weight-bold font-size-lg mb-1 text-black">Sales</h6>
                    <p class="text-black-50 mb-0">Last 7 days sales statistics report</p>
                </div>
            </div>

            <div class="rounded mx-4 my-2 p-4 bg-secondary text-center border-light border-1">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="text-dark pb-1">
                            Today's Earnings
                        </div>
                        <div class="font-size-lg d-flex align-items-center justify-content-center text-second">
                            <span class="mr-2 badge badge-circle badge-dark">Badge dark</span>
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="8490"></span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="text-dark pb-1">
                            Current Week
                        </div>
                        <div class="font-size-lg d-flex align-items-center justify-content-center text-second">
                            <span class="mr-2 badge badge-circle badge-first">Badge first</span>
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="34543"></span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="text-dark pb-1">
                            Previous Week
                        </div>
                        <div class="font-size-lg d-flex align-items-center justify-content-center text-second">
                            <span class="mr-2 badge badge-circle badge-warning">Badge warning</span>
                            <small class="opacity-6 pr-1">$</small>
                            <span [countUp]="76645"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block p-4">
                <canvas [chartType]="'line'"
                        style="height: 250px"
                        [colors]="chartColor2"
                        [datasets]="chartDataset2"
                        [labels]="chartLabels2"
                        [options]="chartOptions2"
                        baseChart></canvas>
            </div>
        </div>
    </div>
</div>
